import { render, staticRenderFns } from "./DsnHelpFooter.vue?vue&type=template&id=3c0a6d42&"
import script from "./DsnHelpFooter.vue?vue&type=script&lang=js&"
export * from "./DsnHelpFooter.vue?vue&type=script&lang=js&"
import style0 from "./DsnHelpFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports